export const en = {
  "footer": {
    "sharedTitle": "The Light of Awareness Forever Shines",
    "contactHeading": "CONTACT & INFO",
    "copyright": "Copyright © 2026 Chung Tai Chan Monastery",
    "address": "Address: No. 2, Chung Tai Rd., Puli Town, Nantou County, Taiwan, ROC",
    "phoneFax": "Tel: 049-2930215 · Fax: 049-2930332",
    "accountName": "Account Name: Chung Tai Chan Buddhist Foundation",
    "email": "Email: ctworld@mail.ctcm.org.tw",
    "version": "Version: {{version}}",
    "monasteryEn": "CHUNG TAI CHAN MONASTERY",
    "anniversaryEn": "35TH ANNIVERSARY"
  },
  "nav": {
    "dna": "Dharma Protector DNA",
    "lampBlessing": "Light a Lamp & Offer a Prayer",
    "quiz": "How Well Do You Know about Chung Tai?",
    "postcard": "Send a Postcard",
    "liveComment": "Chan Heart Connection",
    "jueGuang": "Garden Sightseeing",
    "wishTree": "Wish Tree",
    "anniversary": "",
    "wisdomLamp": "Wisdom Lamp Lighting",
    "transmission": "Chung Tai Dharma Transmission",
    "guardianExpo": "Dharma Protectors' Expo",
    "interactiveSection": "Interactive Zone",
    "dnaShort": "Dharma\nProtector DNA",
    "lampBlessingShort": "Light a Lamp\nWith Prayer",
    "quizShort": "CTCM Quiz",
    "postcardShort": "Send\nPostcards",
    "liveCommentShort": "Chan Heart\nConnection",
    "jueGuangShort": "Garden\nSightseeing",
    "wishTreeShort": "Wish Tree",
    "goToWishTree": "Go to Wish Tree ⮕"
  },
  "header": {
    "logoAlt": "",
    "returnHomeTitle": "Return to Home",
    "guest": "Guest",
    "loggedIn": "Logged in",
    "profile": "Profile",
    "showQrCode": "Show QR Code",
    "login": "Sign In",
    "register": "Register",
    "logout": "Log Out",
    "logoutSuccess": "Logged out successfully",
    "menuTitle": "Menu",
    "copiedToClipboard": "Copied to clipboard: \n{{text}}",
    "copyFailed": "Copy failed: {{error}}"
  },
  "home": {
    "newsGoToBranchReport": "View Report",
    "splashAlt": "Splash",
    "newsTitleLine1": "Latest",
    "newsTitleLine2": "News",
    "newsEmpty": "Coming Soon",
    "showMore": "Show More",
    "viewMore": "View More",
    "videosTitleLine2": "Videos",
    "interactiveTitleLine1": "Interactive",
    "interactiveTitleLine2": "Zone",
    "newsGoTo": "Go",
    "videoViews": "{{count}} views"
  },
  "banner": {
    "registerNow": "Register Now"
  },
  "bottomNav": {
    "home": "Home",
    "videos": "Video Collection",
    "redeem": "Redeem",
    "scan": "Scan"
  },
  "login": {
    "heroTitle": "The Light of Awareness Forever Shines",
    "heroSubtitle": "Commemorating the 35th Anniversary of Chung Tai’s Founding",
    "submit": "Sign In",
    "submitting": "Signing in...",
    "successToast": "Login successful",
    "failureToast": "Login failed: {{message}}"
  },
  "auth": {
    "monasteryLabel": "Affiliated monastery",
    "selectPlaceholder": "Please select",
    "noResults": "No results found",
    "nameLabel": "Name",
    "dharmaNameLabel": "Dharma Name",
    "birthdayLabel": "Birthday",
    "inputPlaceholder": "Please enter",
    "birthdayPlaceholder": "Enter (MMDD / e.g. 0311)",
    "showBirthday": "Show birthday",
    "hideBirthday": "Hide birthday",
    "register": "Register",
    "requiredFieldsAlert": "Please fill in all required fields",
    "birthdayFormatAlert": "Invalid birthday format. Please enter 4 digits (e.g. 0608)",
    "checkInput": "Please check your input",
    "successTitle": "Registration successful"
  },
  "register": {
    "mascotGoldChild": "Golden dome child",
    "mascotElephant": "White elephant",
    "mascotLion": "White lion",
    "mascotDeer": "White deer",
    "defaultEncouragement": "Join Us in Celebrating the 35th Anniversary of Chung Tai’s Founding",
    "titleMember": "Member",
    "mascotLabel": "Choose a mascot",
    "cancel": "Cancel",
    "submitting": "Registering...",
    "failureToast": "Registration failed: {{message}}",
    "enterHome": "Go to Home"
  },
  "redeem": {
    "mascotYAxisWalk": "Walking",
    "mascotYAxisStay": "Standing",
    "mascotYAxisSit": "Sitting",
    "mascotYAxisRest": "Reclining",
    "mascotYAxisPosture": "Deportment",
    "mascotXAxisGoldChild": "Golden Crown Youth",
    "mascotXAxisElephant": "Six-Tusked White Elephant",
    "mascotXAxisLion": "White Lion",
    "mascotXAxisDeer": "White Deer",
    "pageTitle": "Points Redemption",
    "viewRulesAria": "View detailed rules",
    "sectionMascot": "Mascot",
    "sectionVoucher": "Voucher",
    "loading": "Loading...",
    "noMascotRecords": "No mascot records yet",
    "noVoucherRecords": "No voucher records yet",
    "redeeming": "Redeeming",
    "redeem": "Redeem",
    "addedToBag": "Added to treasure bag",
    "redeemFailed": "Redemption failed. Please try again later.",
    "closeAria": "Close",
    "goBackAria": "Go back",
    "mascot": "Mascot",
    "alreadyOwned": "Already owned",
    "viewTreasureBag": "View Treasure Bag",
    "redeemPoints": "Redeem Points",
    "useVoucher": "Redeem with Voucher",
    "insufficientVoucher": "Insufficient Vouchers",
    "insufficientPoints": "Insufficient Points",
    "redeemWithPoints": "Redeem with Points",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "redeemSuccess": "Redemption Successful",
    "noRedeemableMascot": "No redeemable mascots",
    "insufficientForRedeem": "Insufficient vouchers or points",
    "selectRedeemMethod": "Select redemption method",
    "useOneVoucher": "Use 1 voucher for【",
    "pointsForRedeem": "points for【",
    "notFoundMascot": "Mascot not found",
    "scoreBarLabel": "Points (Available / Total)"
  },
  "profile": {
    "blessingHealth": "Physical health",
    "blessingFamily": "Family harmony",
    "blessingDharma": "The fulfillment of the path",
    "blessingStudy": "Excel in Studies",
    "blessingCareer": "Success in Career",
    "blessingConnection": "Develop good affinity with all",
    "mascotYAxisWalk": "Walking",
    "mascotYAxisStay": "Standing",
    "mascotYAxisSit": "Sitting",
    "mascotYAxisRest": "Reclining",
    "sectionZenHeart": "Chan Heart Connection",
    "sectionBlessingLamp": "Light a Lamp & Offer a Prayer",
    "sectionDharmaDNA": "Dharma Protector DNA",
    "sectionChungTai": "How Well Do You Know about Chung Tai?",
    "sectionPostcard": "Send a Postcard",
    "sectionWishTree": "Wish Tree",
    "tabTreasureBag": "Treasure Bag",
    "sectionWisdomLamp": "Light Up the Lamp",
    "sectionTransmission": "Chung Tai Dharma Transmission",
    "noTransmissionRecords": "No support records yet",
    "mascotYAxisPosture": "Deportment",
    "mascotXAxisGoldChild": "Golden Crown Youth",
    "mascotXAxisElephant": "Six-Tusked White Elephant",
    "mascotXAxisLion": "White Lion",
    "mascotXAxisDeer": "White Deer",
    "sectionDharmaTeaching": "Received Dharma Teaching",
    "loading": "Loading...",
    "tabAboutMe": "About me",
    "tabActivityPoints": "Activity points",
    "scoreLabel": "Points (available / total)",
    "nameLabel": "Name",
    "birthdayLabel": "Birthday",
    "dharmaNameLabel": "Dharma name",
    "monasteryLabel": "Affiliated branch",
    "registeredAtLabel": "Registration date",
    "emptyValue": "None",
    "noRecord": "No record",
    "viewRulesAria": "View detailed rules",
    "expandAll": "View all {{count}} records",
    "collapse": "Collapse",
    "sectionPhysical": "Physical Interaction",
    "noCheckInRecords": "No check-in records yet",
    "sectionPoints": "Points Gift",
    "noGiftRecords": "No records yet",
    "noConnectionRecords": "No connection records yet",
    "noSupportRecords": "No support records yet",
    "sectionMascot": "Mascot",
    "noQuizRecords": "No quiz records yet",
    "chipEventTime": "Event time",
    "chipEventLocation": "Event location",
    "chipCheckInTime": "Check-in time",
    "chipDharmaOrName": "Dharma name / Name",
    "chipTime": "Time",
    "avatarInitialFallback": "人",
    "goToRedeemMascot": "Redeem Mascot",
    "postcardSentCount": "Total sent: {{count}} times",
    "wishTreeVowCount": "Vows made: {{count}} times",
    "vowRowAllCollected": "🎉 Congratulations! You've completed the row and earned an extra +{{point}} points",
    "mascotSwipeHint": "Swipe left or right to browse",
    "mascotSetAvatar": "Set as Avatar",
    "sectionSpecialReward": "Special Reward",
    "physicalGiftRedeemed": "Redeemed",
    "specialRewardStage1Title": "5,000-Point Physical Gift Exchange",
    "specialRewardStage2Title": "10,000-Point Physical Gift Exchange",
    "specialRewardStage3Title": "15,000-Point Physical Gift Exchange",
    "specialRewardStage4Title": "20,000-Point Physical Gift Exchange",
    "specialRewardStage1Points": "5,000 point",
    "specialRewardStage2Points": "10,000 point",
    "specialRewardStage3Points": "15,000 point",
    "specialRewardStage4Points": "20,000 point",
    "specialRewardStage1Task": "Event",
    "specialRewardStage2Task": "Event",
    "specialRewardStage3Task": "Event",
    "specialRewardStage4Task": "Event",
    "closeAria": "Close",
    "physicalGiftQrAlt": "Exchange QR Code",
    "physicalGiftQrDesc": "Please show this QR code to staff on-site to complete the exchange",
    "physicalGiftQrFailed": "Failed to get exchange code, please try again later",
    "physicalGiftExchangeSuccess": "Exchange successful",
    "physicalGiftRecordCode": "Exchange code: {{code}}",
    "physicalGiftValidTime": "Valid time: {{time}}",
    "physicalGiftQrExpired": "QR Code has expired",
    "physicalGiftRegenerateQr": "Regenerate QR Code"
  },
  "wisdom-lamp": {
    "introDefault": "",
    "jumpToCurrentWeek": "Go to this week's lamp transmission schedule",
    "mediaTitleBlack": "Transmission of the Lamp",
    "routeMapTitleRed": "Route map",
    "routeMapTagline": "",
    "mapPreviewAlt": "Route map preview",
    "scheduleTitleRed": "Lamp transmission schedule",
    "comingSoon": "Coming soon",
    "mediaTitleRed": "Media Reports",
    "viewMore": "View more",
    "scheduleTitleBlack": "Monasteries",
    "tabByTime": "By time",
    "tabByRegion": "By region",
    "monthSuffix": "month",
    "collapse": "Collapse",
    "expandAll": "Expand all ({{count}})",
    "highlightsTitleBlack": "Event",
    "highlightsTitleRed": "Highlights",
    "openMapHint": "Tap to open map",
    "goToReport": "Go to report",
    "goToMonastery": "Go to monastery"
  },
  "video-collection": {
    "pageTitle": "Video Collection",
    "latestTitleBlack": "Homepage",
    "latestTitleRed": "Videos",
    "lightingTitleBlack": "Wisdom Lamp",
    "lightingTitleRed": "Transmission Videos",
    "wisdomScenesTitleBlack": "Wisdom Lamp",
    "wisdomScenesTitleRed": "Behind the Scenes",
    "jointExhibitionTitleBlack": "Chung Tai Legacy",
    "jointExhibitionTitleRed": "Joint Exhibition Videos",
    "transmissionScenesTitleBlack": "Chung Tai Legacy",
    "transmissionScenesTitleRed": "Event Highlights",
    "viewMore": "View more",
    "collapse": "Collapse",
    "goToReport": "Go to report"
  },
  "quiz": {
    "heroTitle": "How Well Do You Know about Chung Tai?",
    "gameRulesTitle": "Game Instructions",
    "rule1": "This is a single-choice quiz. Once an answer is selected, it cannot be changed.",
    "rule2": "Points are awarded only for the \"Current Week Progress\" and only for the \"first attempt\" at each question.",
    "rule3": "Scoring: 10 points for each correct answer; an additional 50-point bonus is awarded for answering all questions in a chapter correctly.",
    "rule4": "Chapter questions may be attempted again after the designated period has passed, but points will not be re-awarded.",
    "chapterPrevAria": "Previous week",
    "chapterNextAria": "Next week",
    "comingSoon": "Coming soon",
    "startGame": "Start Quiz",
    "processing": "Processing...",
    "loading": "Loading…"
  },
  "quiz-answer": {
    "correctCountLabel": "Correct answers",
    "pointsEarnedLabel": "Points earned this time",
    "pointsUnit": "pts",
    "homeAria": "Back to home"
  },
  "quiz-question": {
    "loadError": "Failed to load questions. Please try again later.",
    "noQuestions": "No questions available.",
    "progress": "Question {{current}} / {{total}}",
    "correctTitle": "Correct!",
    "wrongTitle": "Incorrect!",
    "correctAnswerPrefix": "The correct answer is:",
    "nextAria": "Next question"
  },
  "qr-code": {
    "heroTitle": "QR Code Event Check-in",
    "notLoggedIn": "Not signed in",
    "formatOk": "Format correct",
    "formatError": "Invalid format",
    "checkinSuccess": "Check-in successful",
    "checkinFailed": "Check-in failed",
    "checkinErrorRescan": "Check-in error. Please scan again.",
    "cameraNotReady": "Camera not ready",
    "noCamera": "No camera available on this device",
    "chromeCameraPermission": "Please allow Chrome to use the camera and try again",
    "cameraOpenFailed": "Unable to open camera. Please check permissions.",
    "copiedCode": "Copied barcode content",
    "copyFailed": "Copy failed. Long-press the barcode to copy manually.",
    "activityCheckin": "Event check-in",
    "photoQrFailed": "Unable to recognize QR code from photo",
    "checkingIn": "Checking in…",
    "statusCheckingIn": "Status: Checking in…",
    "scanHint": "Scan a mobile barcode to check in to events or transfer points easily",
    "permissionHint": "Enable camera permission in system settings and return to this page",
    "barcodeError": "Invalid barcode. Please refresh and try again.",
    "manualInputHint": "Enter the same barcode content as scanned",
    "autoSubmitHint": "After a successful scan it will submit automatically; you can also tap Show Mobile Barcode to display your personal code",
    "cameraAria": "Scan camera",
    "closeAria": "Close",
    "alignQrHint": "Align with the event QR code",
    "showQrAria": "Show mobile barcode",
    "accountLabel": "Account:",
    "barcodePlaceholder": "Paste or enter barcode (starts with E or U, 11 characters)",
    "confirm": "Confirm",
    "scanMobileBarcode": "Scan mobile barcode",
    "mobileQrAria": "Mobile barcode",
    "personalQrAlt": "Personal mobile barcode",
    "validTime": "Valid time:",
    "qrLoading": "Loading…",
    "qrLoadFailed": "Failed to load. Please try again later.",
    "generatingQr": "Generating barcode…",
    "showQrDesc": "Show your mobile barcode for scanning to check in or transfer points.",
    "save": "Save",
    "showQrAgain": "Show barcode again",
    "done": "Done",
    "refreshQr": "Refresh barcode",
    "checkinResultAria": "Check-in result",
    "rescanHint": "Tap Rescan to check in again; tap Back to Home when finished",
    "rescan": "Scan again",
    "backHome": "Back to home"
  },
  "card": {
    "shareTitleDefault": "Chung Tai Shan 35th Anniversary Blessing Postcard",
    "shareTitle": "Blessing postcard from {{from}} to {{to}} — Chung Tai Shan 35th Anniversary",
    "ctaTitle": "Want to send a blessing too?",
    "ctaDesc": "Create an exclusive 35th anniversary blessing postcard for loved ones",
    "loading": "Loading postcard…",
    "loadErrorTitle": "Failed to load",
    "loadErrorDesc": "Network or server issue. Please try again later.",
    "reload": "Reload",
    "notFoundTitle": "Postcard not found",
    "notFoundDesc": "The link may have expired or the address is incorrect.",
    "close": "Close",
    "blessingFrom": "Blessing from {{name}}",
    "blessingTo": "To {{name}}",
    "done": "Done",
    "makePostcard": "Make a postcard",
    "shareModalTitle": "Share this postcard",
    "copyLinkLabel": "Copy link",
    "copied": "Copied",
    "copy": "Copy",
    "copyFailHint": "Auto-copy failed. Long-press the link above to copy manually.",
    "shareLineAria": "Share to LINE"
  },
  "postcard": {
    "stepSelectDesign": "Select design",
    "stepFillContent": "Fill in content",
    "share": "Share",
    "toNamePlaceholder": "Recipient name",
    "contentPlaceholder": "Write your blessing here…",
    "fromNamePlaceholder": "Your name",
    "postcardAlt": "Postcard"
  },
  "postcard-create": {
    "itemsLoadError": "Failed to load designs. Please refresh.",
    "requiredFields": "Please fill in sender recipient and blessing message",
    "selectDesignFirst": "Please select a postcard design first",
    "createFailed": "Creation failed. Please try again.",
    "prevStep": "← Previous",
    "creating": "Creating…"
  },
  "postcard-my": {
    "pageTitle": "My Postcards",
    "totalCount": "{{count}} total",
    "add": "Add",
    "loading": "Loading…",
    "emptyTitle": "No postcards yet",
    "emptyHint": "Make one and send it to someone special",
    "createFirst": "Create your first postcard",
    "toLabel": "To"
  },
  "branch-reports": {
    "notFoundRedirect": "Redirecting to Wisdom Lamp page in {{count}} seconds...",
    "noContent": "No report content for this monastery yet",
    "loading": "Loading...",
    "notFoundTitle": "Page not found",
    "backAria": "Go back",
    "likeAria": "Like",
    "featuredTitle": "Featured Monasteries This Week",
    "sectionTitle": "Monastery Lamp Lighting Reports",
    "viewReport": "View report",
    "monasteryCount": "{{count}} locations"
  },
  "live-comment": {
    "heroTitle": "Chan Heart Connection",
    "notLoggedInDesc": "Please sign in or register to join Zen Heart Connection",
    "heroSubtitle": "Select a message board to enter a session",
    "notLoggedInTitle": "Not signed in",
    "loginRegister": "Sign in / Register",
    "comingSoon": "Coming soon",
    "selectSession": "Select a session",
    "backAria": "Back"
  },
  "live-comment-topic": {
    "hotPopupTitle": "Popular comments worth rejoicing",
    "backToSessions": "Back to session list",
    "hotCommentsAria": "Hot comments",
    "reloadAria": "Reload",
    "sortLatest": "Latest",
    "sortMostLiked": "Most liked",
    "refreshAdded": "{{count}} new comments added",
    "refreshNone": "No new comments",
    "submittedPending": "Your comment has been submitted and will appear after review",
    "duplicateError": "You have already posted the same comment. Please change the content and try again.",
    "submitFailed": "Failed to post comment. Please try again later.",
    "boardPaused": "This message board is not accepting comments at the moment",
    "boardEnded": "This message board has ended. Thank you for participating.",
    "placeholder": "Leave your blessing…",
    "submit": "Submit",
    "loginToComment": "Sign in to comment",
    "goLogin": "Go to sign in",
    "likeAria": "Like",
    "hotEmpty": "No hot comments yet",
    "emptyTitle": "No comments yet",
    "emptyHint": "Be the first to leave a blessing",
    "newComments": "{{count}} new comments"
  },
  "lamp-lighting": {
    "blessingHealth": "Physical health",
    "blessingFamily": "Family harmony",
    "blessingDharma": "The fulfillment of the path",
    "blessingStudy": "Excel in Studies",
    "blessingCareer": "Success in Career",
    "blessingConnection": "Develop good affinity with all",
    "blessingHealthDesc": "May body and mind be at ease, blessings and lifespan increase",
    "blessingFamilyDesc": "May the family be harmonious and joyful; children and grandchildren be filial and wise",
    "blessingDharmaDesc": "May wisdom and merit be cultivated together, the path to Buddhahood be fully realized",
    "blessingStudyDesc": "May studies advance and excel and wisdom flow freely without hindrance",
    "blessingCareerDesc": "May all endeavors be fulfilled; all wishes be realized",
    "blessingConnectionDesc": "May relationships be harmonious and virtuous deeds be widely practiced",
    "heroDescription": "Light the lamp before the Buddha; extinguish the fire of affliction within the heart.\r\nMay great wisdom illuminate the darkness of ignorance for all.\r",
    "blessingLabel": "Dedication of Merit",
    "blessingRequired": "Please select Dedication of Merit",
    "heroTitle": "Online Lamp Lighting and Blessings",
    "namePlaceholder": "Name of blessing recipient",
    "submit": "Submit blessing",
    "closeAria": "Close",
    "nameLabel": "Name",
    "nameRequired": "Please enter a name",
    "monasteryLabel": "Meditation Center",
    "submitting": "Submitting...",
    "skipProcessing": "Processing...",
    "skip": "Skip",
    "operationFailed": "Operation failed: {{message}}",
    "tryAgainLater": "Please try again later",
    "monasteryRequired": "Please select a monastery"
  },
  "lamp-bulletin": {
    "pageTitle": "Light Illuminating the Universe",
    "quoteText": "As one lamp kindles a hundred thousand lamps,\r\nthe darkness is brightened, yet the light is never diminished.\r",
    "quoteDedication": "May the merit of this lamp offering be dedicated to all sentient beings throughout the Dharma realm.",
    "offering": "Dedicated",
    "totalLampsPrefix": "Total lamps lit so far:",
    "filterOnlyMine": "Show only my lamps",
    "lightLampCta": "Light a Lamp ",
    "errorNotFound": "This blessing record was not found",
    "errorInvalidId": "Invalid blessing record ID",
    "errorLoadFailed": "Unable to load blessing content. Please try again later.",
    "lampUnit": "lamps",
    "unmuteAria": "Turn on music",
    "muteAria": "Mute",
    "datePlaceholder": "Enter date to search",
    "namePlaceholder": "Enter name to search",
    "cancel": "Cancel",
    "selectDate": "Select date",
    "confirm": "Confirm",
    "yearSuffix": "year",
    "monthSuffix": "month",
    "daySuffix": "day",
    "bgLampAlt": "Background lantern",
    "lampAlt": "Lantern",
    "errorNotYours": "This lamp is not yours.\nPlease search or find your own lamp.",
    "errorNetwork": "Network error. Please check your connection.",
    "errorTimeout": "Request timed out. Please try again later."
  },
  "lamp": {
    "monasteryPlaceholder": "Please select a branch center"
  },
  "dna": {
    "rule1": "For thirty-five years, we are grateful for the wholehearted support of bodhisattvas in all directions. To support the Dharma center is to support the true Dharma! Through everyday intuition, discover the \"Dharma Supporter quality\" within you. Are you the warm sunlight, the steadfast stone, the gentle flowing water, the grounded earth, or the free-drifting clouds?",
    "rule2": "In just 2 minutes, follow your intuition through 10 everyday scenarios and decode your \"Dharma Supporter DNA\"!"
  },
  "dna-answer": {
    "imageAlt": "Dharma Protector DNA",
    "calculating": "Calculating results…",
    "missingRecord": "Missing answer record",
    "enterFromFlow": "Please enter this page from the quiz flow or go back to retake the quiz.",
    "fetchError": "Unable to retrieve results. Please try again later.",
    "backToQuiz": "Back to quiz",
    "imageNotFound": "Image for \"{{name}}\" not found. Please try again later."
  },
  "dna-question": {
    "title": "Find Your Dharma Supporter DNA",
    "progressLabel": "Quiz Progress",
    "quizEyebrow": "PERSONALITY QUIZ",
    "loadingQuestions": "Loading questions…",
    "loadError": "Unable to load questions. Please try again later.",
    "reload": "Reload",
    "noQuestions": "No questions available."
  },
  "jue-guang": {
    "pageTitle": "Garden Sightseeing",
    "statusUpcoming": "Starting soon",
    "statusActive": "Live now",
    "statusEnded": "Ended",
    "comingSoon": "Coming soon",
    "loading": "Loading..."
  },
  "jue-guang-topic": {
    "membersOnlyDesc": "Sign in to upload and share your thoughts!",
    "onlyMyPosts": "Show only my posts",
    "namePlaceholder": "Enter name to search",
    "membersOnlyTitle": "Members only",
    "loginRegister": "Sign in / Register",
    "noData": "No results found",
    "loadMore": "Load more",
    "selectDisplayName": "Please select a display name",
    "fillContent": "Please enter share content",
    "shareSuccessPending": "Shared successfully. It will appear after review.",
    "shareFailed": "Submission failed. Please try again later.",
    "sharePlaceholder": "Share with us...",
    "submitting": "Submitting…",
    "publish": "Publish",
    "landingMembersOnlyDesc": "Sign in to join Garden Sightseeing",
    "clickToUpload": "Tap to upload",
    "photoAlbum": "Photo library",
    "takePhoto": "Take photo",
    "recordVideo": "Record video",
    "durationError": "Video must be 30 seconds or less. Please try again."
  },
  "jue-guang-record": {
    "notFound": "Record not found",
    "back": "Back"
  },
  "transmission": {
    "pageTitle": "Chung Tai Dharma Transmission",
    "introPlaceholder": "(Pending content)",
    "exhibitionInfoTitleBlack": "Exhibition",
    "exhibitionInfoTitleRed": "Map",
    "monasteryTransmissionTitleBlack": "Monastery Exhibition",
    "monasteryTransmissionTitleRed": "List",
    "monasteryListPublishedDesc": "Chung Tai Dharma Transmission opens on {{date}}. Stay tuned!",
    "groupByRegion": "By Region",
    "groupByArea": "By Exhibition Area",
    "jointExhibitionTitleBlack": "Joint Exhibition",
    "jointExhibitionTitleRed": "Videos",
    "highlightsTitleBlack": "Event",
    "highlightsTitleRed": "Highlights",
    "goToMonastery": "Go to monastery",
    "wishTreeTitleBlack": "Wish Tree",
    "wishTreeTitleRed": "Vow",
    "zoneFa": "Fa",
    "zoneShui": "Shui",
    "zoneChang": "Chang",
    "zoneLiu": "Liu",
    "tableDescPlaceholder": "(Pending content)",
    "goToReport": "Go to report"
  },
  "guardianExpo": {
    "pageTitle": "護法薪傳",
    "introSubtitle": "護法會博覽會",
    "introContent": "願承祖師大悲願， 化作禪心菩薩行。 護法薪傳，見賢思齊， 和合精進，用報深恩。 令佛眼不斷，正法永住！",
    "comingSoonDesc": "此展區內容尚在建置中，敬請期待！",
    "back": "返回",
    "relatedActivitiesTitleBlack": "相關",
    "relatedActivitiesTitleRed": "活動",
    "activityVideosTitleBlack": "活動",
    "activityVideosTitleRed": "影音",
    "activityVideosEmpty": "敬請期待",
    "lecture": {
      "title": "講座",
      "subtitle": "(副標題，待補)",
      "pageTitle": "講座展區",
      "introContent": "遠見召喚我們行動。九場專題講座，帶領我們思考如何走向更好的未來！",
      "cardDesc": "遠見召喚我們行動。九場專題講座，帶領我們思考如何走向更好的未來！",
      "scheduleTitleBlack": "講座",
      "scheduleTitleRed": "時程表",
      "photosTitleBlack": "活動",
      "photosTitleRed": "照片"
    },
    "market": {
      "title": "技能交換市集",
      "subtitle": "(副標題，待補)",
      "pageTitle": "技能交換市集",
      "introContent": "一場護法會空前的交流平台，五大學習路線，二十八個智慧小島，淬鍊最精華的實務經驗。藉由相互觀摩，見賢思齊，以期護法技能，全面升級！",
      "cardDesc": "一場護法會空前的交流平台，五大學習路線，二十八個智慧小島，淬鍊最精華的實務經驗。藉由相互觀摩，見賢思齊，以期護法技能，全面升級！",
      "scheduleTitleBlack": "護法技能交換市集",
      "scheduleTitleRed": "場次表",
      "scheduleColumnSession": "場次",
      "scheduleColumnTime": "時間",
      "stampRallyTitleBlack": "集章",
      "stampRallyTitleRed": "活動辦法",
      "conditionsLabel": "兌換條件：",
      "redeemTimeLabel": "兌換時間：",
      "fastPassLabel": "FAST PASS 學習路線：",
      "mapTitleBlack": "市集",
      "mapTitleRed": "地圖",
      "photosTitleBlack": "活動",
      "photosTitleRed": "照片"
    },
    "challenge": {
      "title": "挑戰賽",
      "subtitle": "(副標題，待補)",
      "pageTitle": "挑戰賽展區",
      "introContent": "照遍客塵光自現，機智動員菩薩行。\n這是一場由各精舍「照客組」與「機動組」攜手展現的實務創意競賽。勝負僅是一時的精進助緣，相同的是我們護法護教的願心，永不退轉！",
      "cardDesc": "照遍客塵光自現，機智動員菩薩行。 這是一場由各精舍「照客組」與「機動組」攜手展現的實務創意競賽。勝負僅是一時的精進助緣，相同的是我們護法護教的願心，永不退轉！",
      "scheduleTitleBlack": "挑戰賽",
      "scheduleTitleRed": "賽程表",
      "awardTitleRed": "總排名",
      "scheduleColumnArrival": "到場時間",
      "scheduleColumnMatch": "比賽時間",
      "scheduleColumnDeparture": "離場時間",
      "photosTitleBlack": "活動",
      "photosTitleRed": "照片"
    }
  },
  "transmission-detail": {
    "notFound": "Content not found for this monastery",
    "backToList": "Back to list",
    "backAria": "Back",
    "likeAria": "Like",
    "likeFailed": "Failed to like, please try again later",
    "locateAria": "View on map",
    "locateNotFound": "Could not find this monastery's location on the map",
    "locateFailed": "Failed to locate on map, please try again later",
    "noData": "No content",
  },
  "exhibition-map": {
    "closeAria": "Close",
    "fullscreenAria": "View fullscreen",
    "comingSoon": {
      "title": "Coming Soon",
      "desc": "This area will open on {{date}}. Stay tuned!",
      "descNoDate": "This area is not open yet. Stay tuned!"
    },
    "entrance": {
      "title": "Entrance",
      "shortTitle": "Entrance",
      "subtitle": "",
      "desc": "(Pending content)"
    },
    "zone1": {
      "title": "Zone 1 · Origins & Departure",
      "shortTitle": "Zone 1",
      "subtitle": "",
      "desc": "(Pending content)"
    },
    "zone2": {
      "title": "Zone 2 · Spreading the Dharma, Present Day",
      "shortTitle": "Zone 2",
      "subtitle": "",
      "desc": "(Pending content)"
    },
    "zone3": {
      "title": "Zone 3 · Turning Points & Challenges",
      "shortTitle": "Zone 3",
      "subtitle": "",
      "desc": "(Pending content)"
    },
    "zone4": {
      "title": "Zone 4 · Legacy & the Future",
      "shortTitle": "Zone 4",
      "subtitle": "",
      "desc": "(Pending content)"
    }
  },
  "postcard-view": {
    "blessingFrom": "A blessing from {{name}}",
    "sentTo": "To {{name}}",
    "loading": "Loading postcard…",
    "loadErrorTitle": "Failed to load",
    "loadErrorDesc": "A network or server error occurred. Please try again later.",
    "reload": "Reload",
    "notFoundTitle": "Postcard not found",
    "notFoundDesc": "The link may have expired or is incorrect",
    "close": "Close",
    "share": "Share",
    "done": "Done",
    "wantToSend": "Want to send a blessing too?",
    "makePostcardHint": "Create a special 35th Anniversary postcard for your loved ones",
    "makePostcard": "Make a postcard",
    "sharePopupTitle": "Share this postcard",
    "copyLinkLabel": "Copy link",
    "copy": "Copy",
    "copied": "Copied",
    "copyFailed": "Auto-copy failed. Please long-press the link above to copy manually."
  },
  "latest-news": {
    "backAria": "Go back",
    "noContent": "No content available for this news post"
  },
  "blessing-result": {
    "label": "Grand Master's Sweet Dew of the Dharma",
    "offering": "dedicated by",
    "completeBtn": "Lamp Lit",
    "downloadBtn": "Download",
    "generatingImage": "Generating image",
    "closeAria": "Close",
    "resultAria": "Blessing result"
  },
  "line-browser": {
    "closeAria": "Close",
    "notice": "You are using LINE's built-in browser. Please open this page in your default browser to avoid data loss or functionality issues.",
    "openInBrowser": "Open in default browser"
  },
  "live-badge": {
    "live": "Live now",
    "settled": "Settled",
    "ended": "Ended",
    "upcoming": "Starting soon"
  },
  "commenter-name": {
    "prefix": "Post as",
    "suffix": "",
    "hint": "(Tap name to switch format)"
  },
  "error-page": {
    "notFoundTitle": "Page not found",
    "errorTitle": "Something went wrong",
    "notFoundDesc": "The page you're looking for doesn't exist or has been removed",
    "errorDesc": "The system encountered an issue. Please try again later.",
    "devDetails": "Error details (dev only)",
    "backHome": "Back to home"
  },
  "maintenance": {
    "title": "Under Maintenance",
    "desc": "The website is currently undergoing maintenance"
  },
  "vow-list": {
    "noValue": "N/A",
    "pointSupply": "dedicated by",
    "searchAria": "Search",
    "closeAria": "Close",
    "header": "Lamp Lighting /",
    "totalRecords": "{{count}} records total",
    "noResultsKeyword": "No results for '{{keyword}}'",
    "noRecords": "No lamp lighting records yet"
  },
  "postcard-list": {
    "viewed": "Opened",
    "notViewed": "Not opened",
    "noPoints": "No record",
    "searchPlaceholder": "Search keyword",
    "searchAria": "Search",
    "filterAll": "All shares",
    "filterViewed": "Opened",
    "filterNotViewed": "Not opened",
    "filterAllCards": "All postcards",
    "header": "Postcard Sent Records",
    "closeAria": "Close",
    "totalRecords": "{{count}} records total",
    "totalPoints": "Points: +{{points}}",
    "noResults": "No results found",
    "noRecords": "No postcards sent yet"
  },
  "wish-tree-list": {
    "header": "Vow Records",
    "closeAria": "Close",
    "totalRecords": "{{count}} records total",
    "totalPoints": "Points: +{{points}}",
    "noRecords": "No vows made yet"
  },
  "wish-tree-page": {
    "title": "The Tree of Vows",
    "description": "It is taught that in making vows, one must discipline the mind. In all spiritual cultivation, one aspires to attain the fruition of the Path.\nIf the mind is not firmly committed, there is a risk of regression. As it is said: “If one does not arouse the mind of resolve, nothing can be accomplished.”\nTherefore, all Buddhas and Bodhisattvas, without exception, make great vows and attain enlightenment. This is what is meant by making vows.",
    "totalCount": "Total vows made: ",
    "makeVow": "Make a Vow",
    "treeAlt": "The Tree of Vows",
    "formTitle": "Wholeheartedly, We Make These Vows:",
    "closeAria": "Close",
    "vowerLabel": "Vow Maker",
    "yourName": "Your name",
    "namePlaceholder": "Please enter your name",
    "vowerRequired": "Please enter the vow maker",
    "cardStyleLabel": "Choose a card style",
    "wishTextLabel": "Vow text",
    "wishTextRequired": "Please select a vow text",
    "submitting": "Submitting...",
    "submit": "Hang on the Tree of Vows",
    "unmuteAria": "Turn on music",
    "muteAria": "Mute"
  },
  "board-detail": {
    "loading": "Loading...",
    "closeAria": "Close"
  }
};

export default en;
